export const getHumanPrice = (price: number | null | undefined) => {
  return (price || 0) / 100
}
